module.exports = __webpack_public_path__ + "img/32.a98520bf.png";